<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
      <el-breadcrumb-item>
        <a href="javascript:void(0);" @click="$router.push('/admin/sendEmail/list')" class="aHref">邮件列表</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>编辑邮件</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formUserInfo">
      <el-form ref="form" :model="emailForm" label-width="90px" style="width: 90%;min-width: 800px">
        <el-form-item label="发送对象" style="margin-bottom: 0">
          <el-checkbox-group v-model="emailForm.userType">
            <el-checkbox label="1">用户</el-checkbox>
            <el-checkbox label="2">医生</el-checkbox>
            <el-checkbox label="3" @change="changeCustomChecked">指定邮箱</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="邮箱地址" v-if="customChecked">
          <el-input v-model="emailForm.customEmail"
                    placeholder="指定邮箱,多个邮箱用英文分号( ; )分隔,例：user@email.com; account@email.cn "></el-input>
        </el-form-item>
        <el-form-item label="订阅对象" style="margin-bottom: 0">
          <el-checkbox-group v-model="emailForm.concernType">
            <el-checkbox label="1">新闻</el-checkbox>
            <el-checkbox label="2">研究</el-checkbox>
            <el-checkbox label="3">科普</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="主题">
          <el-input v-model="emailForm.subject"/>
        </el-form-item>

        <el-form-item label="正文" class="quill_parent" prop="pageContent">
          <tinymce v-model="emailForm.content" ref="emailTinymce" :height="356" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="emailForm.remark"/>
        </el-form-item>
        <el-form-item v-loading="loading" style="width: 346px;" v-if="enableEdit">
          <el-button type="primary" @click="send" style="width: 80px;padding: 8px 20px;">发送</el-button>
          <el-button style="width: 80px;padding: 8px 20px;" @click="saveDraft">存草稿</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import base from '@/api/common';

export default {
  name: "sendEmail",
  data() {
    return {
      customChecked: false,
      id: this.$route.query.id,
      emailForm: {
        userType: [],
        concernType: [],
        customEmail: '',
        subject: '',
        content: '',
        remark: ''
      },
      loading: false,
      enableEdit: true,
    }
  },
  components: {
    Tinymce
  },
  mounted() {
    if (this.id) {
      this.$ajax.get(base.basePath + 'communication/comm-email/admin/details/' + this.id).then(res => {
        if (res.data.status === 'success') {
          this.emailForm.customEmail = res.data.data.customEmail;
          this.emailForm.subject = res.data.data.subject;
          this.emailForm.content = res.data.data.content;
          this.emailForm.remark = res.data.data.remark;
          if (res.data.data.userType) {
            this.emailForm.userType = JSON.parse(res.data.data.userType);
            if (this.emailForm.userType.includes('3')) {
              this.customChecked = true;
            }
          }
          if (res.data.data.concernType) {
            this.emailForm.concernType = JSON.parse(res.data.data.concernType);
          }
          if (res.data.data.emailStatus != 0) {
            this.enableEdit = false;
          } else {
            this.enableEdit = true;
          }
        } else {
          this.$message.error('获取数据失败');
        }
      }).catch(err => {
        console.err(err);
        this.$message.error('获取数据失败');
      });
    }
  },
  methods: {
    changeCustomChecked(value) {
      this.customChecked = value;
    },
    send() {
      let that = this;
      if (that.emailForm.userType.length === 0) {
        that.$message.warning('发送对象不能为空');
        return;
      }
      if (that.customChecked) {
        if ($.trim(that.emailForm.customEmail).length === 0) {
          that.$message.warning('邮箱地址不能为空');
          return;
        }
        let customEmails = that.emailForm.customEmail.split(';');
        for (let email of customEmails) {
          email = $.trim(email);
          if (email.length === 0) {
            continue;
          }
          if (!base.reg.email.test(email)) {
            that.$message.warning('邮箱地址内包含错误邮箱');
            return;
          }
        }
      }
      // if(that.emailForm.concernType.length === 0){ that.$message.warning('订阅对象不能为空');return; }
      if ($.trim(that.emailForm.subject).length === 0) {
        that.$message.warning('邮件主题不能为空');
        return;
      }
      if ($.trim(that.emailForm.content).length === 0) {
        that.$message.warning('邮件内容不能为空');
        return;
      }

      // 发送
      let data = {
        userType: JSON.stringify(this.emailForm.userType),
        concernType: JSON.stringify(this.emailForm.concernType),
        customEmail: this.emailForm.customEmail,
        subject: this.emailForm.subject,
        content: this.emailForm.content,
        remark: this.emailForm.remark
      };
      if (this.id) {
        data.id = this.id;
      }
      that.loading = true;
      that.$ajax.post(base.basePath + 'communication/comm-email/admin/send', data).then(res => { //TODO
        if (res.data.status === 'success') {
          that.$message.success('操作成功');
          that.$router.push('/admin/sendEmail/list');
        } else {
          that.$message.error(res.data.message);
          that.loading = false;
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('操作失败');
        that.loading = false;
      })
    },
    saveDraft() {
      // 存草稿,可以不进行其他校验
      if ($.trim(this.emailForm.subject).length === 0) {
        this.$message.warning('邮件主题不能为空');
        return;
      }
      let data = {
        userType: JSON.stringify(this.emailForm.userType),
        concernType: JSON.stringify(this.emailForm.concernType),
        customEmail: this.emailForm.customEmail,
        subject: this.emailForm.subject,
        content: this.emailForm.content,
        remark: this.emailForm.remark
      };
      let url = base.basePath + 'communication/comm-email/admin/draft';
      if (this.id) {
        url = base.basePath + 'communication/comm-email/admin/update/' + this.id;
      }
      this.$ajax.post(url, data).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('保存成功');
          this.id = res.data.data;
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('保存失败');
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.formUserInfo {
  margin-top: 20px;
  border: 1px solid #567BFF;
  padding: 27px;
  position: relative;
}
</style>